module.exports = __webpack_public_path__ + "static/gnoll-b388790ac366e32dac1671ef7a24056e.jpg";